import { ReportOptions, ReportTypes } from '@showbie-socrative/socrative-utils';

import { RoomTypes } from '~analytics/types';
import { ReportOptionState } from '~teacher/components/ExportReports/ReportOption/ReportOptionHookReducer';
import { ReportAnalytics } from '~teacher/components/QuizResultsHeader/ReportAnalyticsContext';

import { sendGenerateReportEvent } from '../index';
import { EventAdapter } from './EventAdapter';

export class GenerateReportEventAdapter extends EventAdapter {
  protected intercomEventKey = null;
  protected amplitudeEventFunction = sendGenerateReportEvent;

  constructor(props: {
    deliveryMethod: 'download' | 'save_to_drive' | 'email';
    reportType: ReportTypes;
    reportOptions: ReportOptionState;
    analytics: ReportAnalytics;
  }) {
    super();

    try {
      const { reportType, reportOptions, deliveryMethod } = props;
      const mappedReportType = this.mapReportType(reportType);

      this.eventData = {
        report_type: mappedReportType,
        delivery_method: deliveryMethod,
        option_omit_mc_answer_content:
          reportOptions[ReportOptions.IncludeMultipleChoiceContent],
        option_include_explanations:
          reportOptions[ReportOptions.IncludeExplanations],
        option_include_correct_answers:
          reportOptions[ReportOptions.IncludeCorrectAnswers],
        activity_student_count: props.analytics.studentCount,
        activity_question_count: props.analytics.questionCount,
        activity_type: props.analytics.activity.activityType,
        activity_room_type: props.analytics.activity.isRostered
          ? RoomTypes.RosteredRoom
          : RoomTypes.OpenRoom,
      };
    } catch (err) {
      console.error('Error parsing analytics data', err);
    }
  }

  mapReportType(reportType: ReportTypes) {
    switch (reportType) {
      case ReportTypes.QuestionSpecificPDF:
        return 'results_summary';
      case ReportTypes.EmptyQuiz:
        return 'answer_key';
      case ReportTypes.WholeClassExcel:
        return 'complete_results';
      case ReportTypes.IndividualStudentPDF:
        return 'individual_students';
      default:
        return null;
    }
  }
}
